import React, { useEffect, useState } from 'react'
import { HEADING } from '../../../../../components/heading/constants/constants';
import Heading from '../../../../../components/heading/Heading';
import Button from '../../../../../components/button/Button';
import { BUTTON_TYPE } from '../../../../../components/button/constants';
import styles from "./AssignMembersTable.styles"
import RichGrid from '../../../../../components/richgrid/RichGrid';
import Label from '../../../../../components/label/Label';
import TextInput from "../../../../../components/input/textinput/TextInput"
import IconLabel from '../../../../../components/iconlabel/IconLabel';
import { LABEL_WEIGHT } from '../../../../../components/label/constants';
import { ASSIGN_MEMBER_LOADING_STATES, ASSIGN_MEMBER_MESSAGE_MAP, MEMBERS_DATA } from './constants';
import VerticalSeparator from '../../../../../components/separator/verticalseparator/VerticalSeparator';
import { ROW_SELECTION_OPTIONS } from '../../../../../components/richgrid/constants';
import MultiSelectDropdownWLabel from '../../../../../components/dropdown/multiselectdropdownwlabel/MultiSelectDropdownWLabel';
import { VEC_ICON_NAME } from '../../../../../components/icons/constants';
import Loadable from '../../../../../components/loadable/Loadable';
import { useDispatch, useSelector } from 'react-redux';
import { componentKey, setSelectedMembersUsersList, setAssignPayerPaginationState, setMemberUserRoles } from '../AssignMembersSlice';
import { assignToUser, getMemberRoles, getMemberUsersList } from '../AssignMembersSaga';
import useGarbageCollector from '../../../../../../libs/garbagecollector/garbageCollectorHooks';
import Popup from '../../../../../components/popup/Popup';
import { addNotifications } from '../../../../toaster/ToasterPortalSlice';
import useTxNavigate from '../../../../../../libs/txnavigate/TxNavigateHook';

export default function AssignMembersTable({
    selectedPayersList = [],
    payerDetails = {},
    isPopup = true,
    isPopupOpen = false,
    onPopupCloseCb = () => { },
    title = "",
    onAssignCb = null,
}) {

    useGarbageCollector(componentKey);
    const dispatch = useDispatch();
    const navigate = useTxNavigate();

    const { loadingState, memberRolesLoadingState, memberUsersList, selectedMemberUsersList, assignPayerPaginationState, memberUserRoles } = useSelector(state => state[componentKey])

    useEffect(() => {
        dispatch(getMemberUsersList({ ...assignPayerPaginationState, payerDetails }));
        dispatch(getMemberRoles());
    }, [])

    const ApplyButton = {
        type: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
        children: "Apply",
        onClickCb: () => console.log('apply button clicked: ', roleFilterOptions), // call the API on this callback
    }

    const handleFilterInputSearch = (e = null) => {
        if(e === null || e.key === "Enter"){
            dispatch(getMemberUsersList({ ...assignPayerPaginationState, Skip: 0, PageNumber: 1}))
            dispatch(setAssignPayerPaginationState({ Skip: 0, PageNumber: 1 }))
        }
    }

    const TableActions = (
        <div style={styles.tableActions}>

            <div>
                <Label>{selectedMemberUsersList.length} member users assigned</Label>
                <Button
                    type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER}
                    style={{ ...styles.addUserBtn, ...styles.leftSpacing }}
                    onClickCb={() => dispatch(setSelectedMembersUsersList([]))}
                >
                    Clear
                </Button>
            </div>

            <VerticalSeparator />

            <div>
                <TextInput
                    placeHolder="Search member user"
                    suffixProps={{
                        icon: VEC_ICON_NAME.SEARCH_ICON, suffixIconCb: () => handleFilterInputSearch()
                    }}
                    customStyles={styles.searchMemberInput}
                    hideBorder
                    value={assignPayerPaginationState?.FilterText}
                    onChangeCb={(e) => dispatch(setAssignPayerPaginationState({ FilterText: e.target.value }))}
                    onKeyDownCb={(e) => handleFilterInputSearch(e)}
                />
            </div>

            <VerticalSeparator />

            <Loadable currentState={memberRolesLoadingState.state} loadingStates={[ASSIGN_MEMBER_LOADING_STATES.GET_MEMBER_ROLES_LOADING]} messageMap={ASSIGN_MEMBER_MESSAGE_MAP} isNewLoadable={true}>
                <div>
                    <MultiSelectDropdownWLabel
                        label="All roles"
                        options={memberUserRoles}
                        onChangeCheckboxCb={(options) => dispatch(setMemberUserRoles(options))}
                        buttonProps={[ApplyButton]}
                    />
                </div>
            </Loadable >

            <VerticalSeparator />

            <div>
                <IconLabel
                    text="Add user"
                    icon={VEC_ICON_NAME.CIRCULAR_PLUS_ICON}
                    labelStyles={styles.leftSpacing}
                    onClickCb={() => navigate(`/users/manageusers?action=adduser`)}
                />
            </div>

        </div>
    );

    const ASSIGN_MEMBER_COLUMNS = [
        {
            field: "memberName",
            header: <Label weight={LABEL_WEIGHT[700]} customStyles={{ ...styles.text, ...styles.memberName }}>Member user name</Label>,
            renderLogic: (row, idx) => <span style={{ ...styles.text, ...styles.memberName }}>{row?.UserName}</span>
        },
        {
            field: "email",
            header: <Label weight={LABEL_WEIGHT[700]}>User Email</Label>,
            renderLogic: (row, idx) => <span style={styles.text}>{row?.UserEmail}</span>
        },
        {
            field: "role",
            header: <Label weight={LABEL_WEIGHT[700]}>Roles</Label>,
            renderLogic: (row, idx) => <span style={styles.text}>{row?.Role}</span>
        },
        {
            field: "Field 3",
            header: TableActions,
            renderLogic: (row, idx) => <></>
        },
    ];

    const AssignMemberTableJSX = (
    <Loadable currentState={loadingState.state} loadingStates={[ASSIGN_MEMBER_LOADING_STATES.GET_MEMBER_USERS_LIST_LOADING, ASSIGN_MEMBER_LOADING_STATES.ASSIGN_TO_USER_LOADING]} messageMap={ASSIGN_MEMBER_MESSAGE_MAP} isNewLoadable={true}>
    <div className='w-100' style={styles.mainContainer}>
        <div style={styles.headingContainer}>
            <Heading type={HEADING.H1}>{title ? title : `Which member users should ${payerDetails?.FirstName || ''} ${payerDetails?.LastName} be assigned to?`}</Heading>
            <div style={styles.subTextContainer}>
                <p>Unable to find a member user?</p>
                <Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} style={styles.addUserBtn} onClickCb={() => navigate(`/users/manageusers?action=adduser`)}>Add User</Button>
            </div>
        </div>

        <div style={styles.buttonsContainer}>
            <Button
                type={BUTTON_TYPE.PRIMARY}
                style={styles.button}
                onClickCb={() => {
                    if (selectedMemberUsersList?.length) {
                        if (onAssignCb) {
                            onAssignCb(selectedMemberUsersList);
                        } else {
                            dispatch(assignToUser({ selectedPayers: selectedPayersList, PayerDetailId: payerDetails?.PayerDetailId, selectedMemberUsersList, onPopupCloseCb }))
                        }
                    } else {
                        dispatch(addNotifications({ heading: "Error", message: "Please select at least one member to Assign Payer to" }))
                    }
                }}>
                Assign
            </Button>

        </div>

        <div>
            <RichGrid
                data={memberUsersList}
                columns={ASSIGN_MEMBER_COLUMNS}
                selectable={true}
                extractRowKey={(row) => row.UserId}
                onSelectionChangeCallBack={(selectedData) => dispatch(setSelectedMembersUsersList(selectedData))}
                onHeaderSelectionChangeCallBack={(selectedData) => dispatch(setSelectedMembersUsersList(selectedData))}
                selectedRows={selectedMemberUsersList}
                paginationProps={{
                    skip: assignPayerPaginationState?.Skip,
                    take: assignPayerPaginationState?.PageSize,
                    takeOptions: ROW_SELECTION_OPTIONS,
                    onChangeTakeCb: (newTake) => {
                        dispatch(getMemberUsersList({ ...assignPayerPaginationState, PageSize: newTake, Skip: 0, PageNumber: 1 }))
                        dispatch(setAssignPayerPaginationState({ PageSize: newTake, Skip: 0, PageNumber: 1 }))
                    },
                    total: assignPayerPaginationState.totalRecords,
                    onChange: (take, t) => {
                        dispatch(getMemberUsersList({ ...assignPayerPaginationState, PageSize: take, Skip: t, PageNumber: Math.ceil((take + t) / take) }))
                        dispatch(setAssignPayerPaginationState({ PageSize: take, Skip: t, PageNumber: Math.ceil((take + t) / take) }))
                    },
                }}
            />
        </div>
    </div >
    </Loadable>
    )

    return (
        <>
            {isPopup ?

                <Popup title={""} onCloseCb={onPopupCloseCb} isPopupOpen={isPopupOpen} customPopupSyles={styles.popupStyles} overlayStyles={styles.popupoOverlay} childrenStyles={styles.popupChildrenStyles}>
                    {AssignMemberTableJSX}
                </Popup>

                :

                AssignMemberTableJSX
            }
        </>
    )
}